import {
  AssetType,
  getLoanById,
  getLocaleByPurchaseCountry,
  getOrderDetailsByLoanId,
  Loan,
  OrderStatus,
} from '@nemuru-eng/js-api-client';
import { useMemo, useState } from 'react';

import { useCache } from '@/hooks/requests/useCache';
import { useNemuruJs } from '@/hooks/useNemuruJs';

import { ALLOWED_LOAN_STATUSES_EXTERNAL_FOR_REFUND } from '../constants/statusesLists';

export const useOrderRefund = (loan: Loan) => {
  const isOrder = loan.assetReference[0].type === AssetType.ORDER;
  const { loadNemuruJsWithAgent, openOrderManagement, loadingNemuruJs } = useNemuruJs();
  const { revalidate: revalidateLoan } = useCache(getLoanById, { loanId: loan.id });
  const { data: orderDetails, revalidate: revalidateOrder } = useCache(
    getOrderDetailsByLoanId,
    isOrder ? { loanId: loan.id } : null,
  );

  const isOrderRefundable = useMemo<boolean>(
    () =>
      !!orderDetails &&
      ALLOWED_LOAN_STATUSES_EXTERNAL_FOR_REFUND.includes(orderDetails.status) &&
      orderDetails.order.status === OrderStatus.CONFIRMED,
    [orderDetails],
  );

  const [initialized, setInitialized] = useState(false);

  const openRefund = async () => {
    if (!initialized) {
      await loadNemuruJsWithAgent(loan.agentId, {
        currency: orderDetails?.currency,
        locale: getLocaleByPurchaseCountry(loan.purchaseCountry),
      });
      setInitialized(true);
    }

    const options = {
      onClose: onCloseRefund,
    };

    openOrderManagement(loan.id, options);
  };

  const onCloseRefund = async () => {
    await revalidateLoan();
    await revalidateOrder();
  };

  return { openRefund, isOrderRefundable, loadingNemuruJs };
};
